var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterCircleFill = function SvgFilterCircleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10M4.375 6.25h11.25a.625.625 0 1 1 0 1.25H4.375a.625.625 0 1 1 0-1.25m1.875 4.375c0-.345.28-.625.625-.625h6.25a.625.625 0 1 1 0 1.25h-6.25a.625.625 0 0 1-.625-.625m2.5 3.75c0-.345.28-.625.625-.625h1.25a.625.625 0 1 1 0 1.25h-1.25a.625.625 0 0 1-.625-.625"
  })));
};
export default SvgFilterCircleFill;